const PREFIX = 'satcb.banner.dismissed.';

export function getBannerStorageKey(key) {
  return `${PREFIX}${key}`;
}

export function isBannerDismissed(key) {
  try {
    return sessionStorage.getItem(getBannerStorageKey(key)) === '1';
  } catch (e) {
    return false;
  }
}

export function dismissBanner(key) {
  try {
    sessionStorage.setItem(getBannerStorageKey(key), '1');
  } catch (e) {
    // ignore
  }
}